import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useNavigate } from "react-router-dom";
import StandardDatePicker from "./StandardDatePicker";
import TablePagination from "./TablePagination";

const ClientDataEntryLayer = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [reportData, setReportData] = useState([
        { id: 1, keyPerson: "John Doe", companyName: "Elite Constructions", location: "Chennai", eventCount: 8, mobileNumber: "9000010001", email: "john@elite.com" },
        { id: 2, keyPerson: "Sarah Smith", companyName: "Modern Interiors", location: "Madurai", eventCount: 4, mobileNumber: "9000020002", email: "sarah@modern.com" }
    ]); 
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const filteredData = reportData.filter(item => 
        item.keyPerson.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.companyName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden border-0 shadow-sm">
            <div
                className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between"
                style={{ background: "linear-gradient(135deg, #000000, #bb0007, #ed1c24)" }}
            >
                <h6 className="text-white mb-0 fw-bold text-uppercase">Client Data Entry Report</h6>
                
                <div className="position-relative" style={{ width: "280px" }}>
                    <input 
                        type="text" 
                        className="form-control form-control-sm radius-8 ps-32" 
                        placeholder="Search Client Name..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ 
                            backgroundColor: "rgba(255, 255, 255, 1)", 
                            border: "1px solid rgba(255,255,255,0.2)", 
                            color: "black",
                            fontWeight: "500"
                        }}
                    />
                    <Icon 
                        icon="solar:magnifer-linear" 
                        className="position-absolute start-0 top-50 translate-middle-y ms-12 text-dark opacity-75" 
                    />
                </div>
            </div>
            <div className="card-body p-16">
                <div className="table-responsive border radius-8 bg-white overflow-hidden shadow-sm mb-16">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                                <th className="fw-bold text-white text-xs py-12">Client Name</th>
                                <th className="fw-bold text-white text-xs py-12">Company Name</th>
                                <th className="fw-bold text-white text-xs py-12">Location</th>
                                <th className="fw-bold text-white text-xs py-12 text-center">Event Count</th>
                                <th className="fw-bold text-white text-xs py-12 text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length > 0 ? (
                                filteredData.map((item, index) => (
                                    <tr key={index}>
                                        <td className="py-10">
                                            <div className="fw-bold text-dark" style={{ fontSize: "13px" }}>{item.keyPerson}</div>
                                            <div className="text-secondary-light" style={{ fontSize: "11px" }}>{item.email}</div>
                                        </td>
                                        <td className="py-10">
                                            <div className="text-dark fw-medium" style={{ fontSize: "12px" }}>{item.companyName}</div>
                                        </td>
                                        <td className="py-10">
                                            <div className="text-dark" style={{ fontSize: "12px" }}>{item.location}</div>
                                        </td>
                                        <td className="py-10 text-center">
                                            <span className="badge rounded-pill bg-info-focus text-info-main px-12 py-6 fw-bold" style={{ fontSize: "11px" }}>
                                                {item.eventCount}
                                            </span>
                                        </td>
                                        <td className="py-10 text-center">
                                            <Link
                                                to={`/reports/client-data-entry/view/${item.id}`}
                                                className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-32-px h-32-px d-inline-flex justify-content-center align-items-center rounded-circle border-0"
                                                title="View Details"
                                            >
                                                <Icon icon="majesticons:eye-line" className="text-lg" />
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center py-24 text-secondary-light">
                                        No matching clients found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <TablePagination
                    currentPage={currentPage}
                    totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                    onPageChange={(page) => setCurrentPage(page)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => {
                        setCurrentPage(0);
                    }}
                    totalRecords={filteredData.length}
                />
            </div>
        </div>
    );
};

export default ClientDataEntryLayer;
